export const CONTRACT_TO_HIRE = 2
export const SOURCING_FEE_DEFAULT = 0
export const OTHER_EXPENSES_DEFAULT = 0
export const LENGTH_OF_CONTRACT_DEFAULT = 6
export const CONVERSION_FEE_DEFAULT = 0
